module.exports = __webpack_public_path__ + "img/step5.beefda2f.png";